define('modules/editor/views/property_boxes/form_content',['require','exports','module','./base','ldsh!../../templates/property_boxes/form_content'],function(require, exports, module) {
  "use strict";
  var BasePropertyBox = require("./base");

  var Controller = {
    requestFormContent: function(e) {
      e.preventDefault();
      var formModel = this.model.parent.toJSON();
      this.model.parent.editFormFields();
      // this.data.services.request("form:content", this.model.parent.toJSON(),
      //   _.bind(this.model.parent.saveFormEditorData, this.model.parent));
    }
  };

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/form_content"),
    myEvents: {
      "click .js-edit-form": "requestFormContent"
    },
    initialize: function(){
      _.extend(this.events, this.myEvents);
      module.exports.__super__.initialize.apply(this,arguments);
    }
  });

  _.extend(module.exports.prototype, Controller);

});
